import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useSound from 'use-sound';
import QuestionswithTextField from '../QuestionswithTextField';
import { checkPremiumStatus } from '../../utils/auth';


import { Link } from 'react-router-dom';
import NewQuestionBox from '../NewQuestionBox';
import ImagewithTextField from '../ImagewithTextField';
import TexttoSpeechwithTextfield from '../TexttoSpeechwithTextfield';
import ImagewithRadio from '../ImagewithRadio';
import CorrectAnswers from '../CorrectAnswers';
import FeedBackPopup from './FeedBackPopup';
import MailIcon from '../../assets/images/email.png';


import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import { UserContext } from '../UserContext';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';
import { LocationContext } from '../../reducers/LocationContext';
import DrawShapeswithTextField from './DrawShapeswithTextField';
import TexttoSpeechwithRadioButton from "../../components/TexttoSpeechwithRadioButton";

import { withAuthenticator } from 'aws-amplify-react';
import Timer from '../Timer';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

import { default as animationData1 } from '../../assets/congratulations.json';
import { default as animationData2 } from '../../assets/tryagain.json';
import { ConsoleLogger } from '@aws-amplify/core';
import { faLessThanEqual, faToiletPaper } from '@fortawesome/free-solid-svg-icons';
import { cx } from '@emotion/css';
import { button } from '../../styles/components/buttons.style';
import * as styles from '../../components/quizApp.style';
import Confetti from 'react-confetti';
import MapwithRadio from '../MapwithRadio';
import ListenSpeech from '../ListenSpeech';
import ImagesasOptions from '../ImagesasOptions';

Amplify.configure(config);

function PracticeQuiz(props) {
  const history = useHistory();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const { subscriptionStatus } = useContext(SubscriptionContext);

  // Track if this is the first mount
  const firstMount = React.useRef(true);

  // Track if we've already incremented the attempt counter for this session
  const attemptIncremented = React.useRef(false);

  // Function to end the current practice session
  const endPracticeSession = async () => {
    try {
      const [username] = await getToken();
      if (username) {
        const sessionData = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
        if (sessionData.username === username) {
          sessionStorage.removeItem(PRACTICE_SESSION_KEY);
          console.log('Practice session ended properly');
        }
      }
    } catch (error) {
      console.error('Error ending practice session:', error);
    }
  };

  // Initialize quiz when component mounts
  // Function to handle beforeunload event
  const handleBeforeUnload = (e) => {
    // Only show warning if there's an active practice session
    const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
    if (activeSession.active) {
      e.preventDefault();
      e.returnValue = 'Are you sure you want to leave? Your practice attempt may be counted.';
      return e.returnValue;
    }
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    // Add event listeners
    window.addEventListener('beforeunload', handleBeforeUnload);

    const initializeQuiz = async () => {
      try {
        console.log('Initializing quiz...');
        const [username, jwt] = await getToken();
        if (!username) {
          console.log('No username found');
          return;
        }

        // Check if user is premium
        const { isPremium } = await checkPremiumStatus();
        if (isPremium) {
          console.log('Premium user, no practice limits');
          setIsLoading(false);
          // Clear any existing practice session for premium users
          sessionStorage.removeItem(PRACTICE_SESSION_KEY);
          return;
        }

        // Check for active practice session
        const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
        if (activeSession.username === username && activeSession.active) {
          console.log('Resuming active practice session');
          setIsLoading(false);
          return;
        }

        // Get current practice count
        const sessionPracticeData = JSON.parse(sessionStorage.getItem(PRACTICE_ATTEMPTS_KEY) || '{}');
        const practiceCount = sessionPracticeData[username] || 0;

        console.log(`Practice attempts for ${username}:`, practiceCount);

        // For non-first attempts, check limits
        if (practiceCount > 0) {
          console.log('Subsequent attempt - checking limits');
          const { allowed } = await checkPracticeLimits();
          if (!allowed) {
            console.log('Practice not allowed, redirecting to subscription');
            return;
          }
        } else {
          // Start a new practice session for first attempt
          sessionStorage.setItem(PRACTICE_SESSION_KEY, JSON.stringify({
            username,
            active: true,
            startTime: new Date().toISOString(),
            path: location.pathname
          }));
        }

        // If we get here, practice is allowed
        console.log('Loading quiz content...');

      } catch (err) {
        console.error('Error initializing quiz:', err);
        if (isMounted) {
          setError('Failed to initialize quiz. Please try again.');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initializeQuiz();

    // Handle component unmount
    return async () => {
      isMounted = false;

      try {
        const [username] = await getToken();
        if (username) {
          const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');

          // Clear the active session without incrementing counter
          // We only want to increment on actual submission, not on navigation away
          sessionStorage.removeItem(PRACTICE_SESSION_KEY);
        }
      } catch (error) {
        console.error('Error cleaning up practice session:', error);
      }
    };
  }, [location.pathname]); // Re-run if path changes

  const { countryCode } = useContext(LocationContext);

  const [isfbackOpen, setIsfbackOpen] = useState(false);
  var [fdback_id, set_fdback_id] = useState(0);

  const [questionBank, set_questionBank] = useState([]);
  const [score, set_score] = useState(0);
  const [attendedquestions, set_attendedquestions] = useState(0);

  const [newevent, set_newevent] = useState({});
  const incrementScore = () => set_score(score + 1);
  const [noofquestionsattended, set_noquestionsattended] = useState(0);
  const [questionnumber, set_questionnumber] = useState(1);
  const [useranswer, set_useranswer] = useState('');
  const [totalquestions, set_totalquestions] = useState(0);

  var [start_limit, set_start_limit] = useState(0);
  var [end_limit, set_end_limit] = useState(0);
  var [randomize, set_randomize] = useState(true);


  const [finished, is_finished] = useState(false);
  const [reviewed, is_reviewed] = useState(false);
  const [isNavigatingReview, setIsNavigatingReview] = useState(false);
  const [questionwithtextfield, is_questionwithtextfield] = useState(false);
  const [imagewithtextfield, is_imagewithtextfield] = useState(false);
  const [mapwithradiobuttons, is_mapwithradiobuttons] = useState(false);
  const [imagewithradio, is_imagewithradio] = useState(false);
  var dummy = 0
  var wronganswer = false
  var passed = false
  var activityusername = ''

  const [drawquestions, is_drawquestions] = useState(false);

  const [questionwithradio, is_questionwithradio] = useState(false);
  const [questionwithimages, is_questionwithimages] = useState(false);

  const [texttospeechwithtextfield, is_texttospeechwithtextfield] =
    useState(false);
  const [texttospeechwithradiobutton, is_texttospeechwithradiobutton] =
    useState(false);

  const [listenspeech, is_listenspeech] = useState(false);


  const [wrongansweredquestions, set_wrongansweredquestions] = useState([]);

  //const [user_answers, set_user_answers] = useState([]);
  const [user_answers_right, set_user_answers_right] = useState({});
  const [user_answers_right1, set_user_answers_right1] = useState({});
  const [event_activity_answers, set_event_activity_answers] = useState({});
  const [real_answers, set_real_answers] = useState({});

  const [case_checker, set_case_checker] = useState({});


  // const [jwt_token, set_jwt_token] = useState({});
  const [username, set_username] = useState({});
  const [email, set_email] = useState({});

  const [hasUsedCorrectMistakes, setHasUsedCorrectMistakes] = useState(false);
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [isLoadingMistakes, setIsLoadingMistakes] = useState(false);

  const [presentquestion, set_presentquestion] = useState({
    answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
    attempts: 0,
    category: 'Sports',
    correctanswer: 'Russia',
    failures: 0,
    id: 0,
    level: 3,
    question: 'Which country hosted 2014 Winter Olympics?',
    specificcategory: 'Olympics',
    subcategory: 'Sports',
  });
  const { user } = useContext(UserContext);
  let data1 = useLocation();
  //Add memo for optmize question loading
  // const [questionBank, set_questionBank] = useState([]);

  const optimizedQuestionBank = useMemo(() => {
    return questionBank.map((question, index) => {
      // Perform any expensive computation here
      return {
        ...question,
        index,
      };
    });
  }, [questionBank]);

  function togglePopup() {


    setIsOpen(!isOpen);
  }

  function togglePopupwithId(id) {

    setIsfbackOpen(!isfbackOpen);
    set_fdback_id(id)

  }



  const [playActive] = useSound(
    '../assets/pop.mp3',
    { volume: 0.25 }
  );

  const [playNext] = useSound(
    '../assets/nextorback.mp3',
    { volume: 0.25 }
  );



  const [playPass] = useSound(
    '../assets/pass.mp3',
    { volume: 0.50 }
  );

  const [playFail] = useSound(
    '../assets/fail.mp3',
    { volume: 0.25 }
  );

  const [playTick] = useSound(
    '../assets/tick.mp3',
    { volume: 0.50 }
  );


  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const session = await Auth.currentSession();
      const jwt = session.getIdToken().getJwtToken();
      const username = user.username.includes("Google_")
        ? user.attributes.email
        : user.username;
      return [username, jwt];
    } catch {
      return [null, null];
    }
  };

  // Track practice attempts in session storage
  const PRACTICE_ATTEMPTS_KEY = 'practiceAttempts';
  const PRACTICE_SESSION_KEY = 'practiceSession';
  const MAX_FREE_ATTEMPTS = 1; // Limit to 1 practice per session for free users

  const checkPracticeLimits = async () => {
    try {
      console.log('Checking practice limits...');
      const [username, jwt] = await getToken();

      // If we can't get user info, allow access to prevent blocking
      if (!username || !jwt) {
        console.log('No user session found, allowing access');
        return { allowed: true, isPremium: false };
      }

      // Check if user is premium
      const { isPremium } = await checkPremiumStatus();
      if (isPremium) {
        console.log('Premium user, no practice limits');
        // Clear any existing practice session for premium users
        sessionStorage.removeItem(PRACTICE_SESSION_KEY);
        return { allowed: true, isPremium: true };
      }

      // Check for active practice session
      const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
      if (activeSession.username === username && activeSession.active) {
        console.log('Active practice session found, allowing access');
        return { allowed: true, isPremium: false };
      }

      // Get current practice count
      const sessionPracticeData = JSON.parse(sessionStorage.getItem(PRACTICE_ATTEMPTS_KEY) || '{}');
      const practiceCount = sessionPracticeData[username] || 0;

      console.log(`Practice attempts for ${username}:`, practiceCount);

      // If this is the first attempt, allow it and start a new session
      if (practiceCount === 0) {
        console.log('First attempt - starting new practice session');
        // Mark the start of a practice session
        sessionStorage.setItem(PRACTICE_SESSION_KEY, JSON.stringify({
          username,
          active: true,
          startTime: new Date().toISOString(),
          path: location.pathname
        }));
        return { allowed: true, isPremium: false };
      }

      // For second or subsequent attempts, show subscription prompt
      console.log('Subsequent attempt - showing subscription prompt');
      if (!window.location.pathname.includes('subscription')) {
        history.push({
          pathname: '/subscription',
          state: {
            message: 'You have used your free practice attempt. Upgrade to premium for unlimited practice!',
            from: window.location.pathname
          }
        });
      }
      return { allowed: false, isPremium: false };

    } catch (error) {
      console.error('Error in checkPracticeLimits:', error);
      // On error, allow access to prevent blocking users
      return { allowed: true, isPremium: false, error: true };
    }
  };

  let answ = [];

  const updateEventyActivity = async (updatedscore) => {
    if (!questionBank || questionBank.length === 0) return;

    let eventanswermap = {};
    let wronganswers = [];
    const userAnswers = user_answers_right || {};
    const answers = real_answers || {};
    const answ = [];
    let passed = false;

    // Process each question in the question bank
    questionBank.forEach((question, index) => {
      const questionId = question.id;
      const userAnswer = userAnswers[questionId];
      const correctAnswer = question.correctanswer;
      let isWrong = false;

      // Format question text based on type
      const questionText = imagewithtextfield
        ? `<img src="${question.question}" height="100px" width="100px" />`
        : question.question;

      // Store question and answer information
      answ[index] = `Q: ${index} Question: ${questionText} ` +
        `Correct Answer: ${correctAnswer} ` +
        `Your selection: ${userAnswer || 'Not answered'}`;

      // Check if answer is wrong or not provided
      if (!userAnswer) {
        isWrong = true;
      } else {
        const correctAnswers = Array.isArray(answers[questionId])
          ? answers[questionId]
          : [String(answers[questionId] || '')];

        const userAnswerStr = String(userAnswer).trim();
        const isCaseSensitive = question.ignorecases !== "true";

        if (isCaseSensitive) {
          isWrong = !correctAnswers.includes(userAnswerStr);
        } else {
          const lowerCorrectAnswers = correctAnswers.map(a => String(a).toLowerCase().trim());
          isWrong = !lowerCorrectAnswers.includes(userAnswerStr.toLowerCase());
        }
      }

      // Track wrong answers
      if (isWrong) {
        wronganswers.push(question);
      }

      // Map correct answer to user's answer
      eventanswermap[correctAnswer] = userAnswer || '';
    });

    // Update state with wrong answers
    if (wronganswers.length > 0) {
      set_presentquestion(wronganswers[0]);
    }
    set_wrongansweredquestions(wronganswers);

    // Check if user passed
    passed = updatedscore >= questionBank.length;

    try {
      // Get current authenticated user
      const user = await Auth.currentAuthenticatedUser();
      const username = user.username.includes("Google_")
        ? user.attributes['email']
        : user.username;

      // Prepare request data
      const requestData = {
        eventid: data1.state?.id || '',
        eventname: data1.state?.name || 'Practice Quiz',
        username: username,
        score: updatedscore,
        timetaken: 10, // Default time taken
        targetscore: questionBank.length,
        level: (data1.state?.level || '').replace('Grade', ''),
        passed: passed,
        operation: 'practice',
        description: data1.state?.name || 'Practice Quiz',
        emailid: email || '',
        category: data1.state?.category || 'general',
        correctanswers: answ,
        eventtype: 'practice',
        qualificationno: questionBank.length,
        emailtobesend: data1.state?.sendEmail || false,
        eventemailid: data1.state?.email || 'email',
        useranswers: eventanswermap,
      };

      // Send data to API
      const response = await fetch(
        'https://api.prod.quizwizard.net/quiz/updatepracticeactivity',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log('Activity updated:', responseData);

    } catch (error) {
      console.error('Error updating activity:', error);
    } finally {
      is_finished(true);
    }
  };

  useEffect(() => {
    // Check if user is premium when component mounts
    const checkPremium = async () => {
      try {
        const { isPremium } = await checkPremiumStatus();
        setIsPremiumUser(isPremium);
      } catch (error) {
        console.error('Error checking premium status:', error);
      }
    };

    checkPremium();
  }, []);

  async function reviewscreen() {
    is_reviewed(true);
    setIsNavigatingReview(false);

    // End the practice session when user finishes the quiz
    await endPracticeSession();

    var key, val, count = 0;
    for ([key, val] of Object.entries(user_answers_right)) {
      count = count + 1;
    }





    set_attendedquestions(count);
  }

  function ReviewAnswers(questno) {
    const questionToReview = questionBank[questno];
    is_reviewed(false); // Show the question component, not the review table
    setIsNavigatingReview(true); // Enter review navigation mode
    set_presentquestion(questionToReview);
    set_questionnumber(questno + 1); // questno is 0-indexed, so +1 is correct for display
    updateQuestionTypeState(questionToReview.displayformat);
  }

  // Function to handle playing the quiz again with wrong answers
  async function playagain() {
    try {
      setIsLoadingMistakes(true);

      // If user is not premium, redirect to subscription immediately
      if (!isPremiumUser) {
        history.push('/subscription');
        return;
      }

      // Save the wrong answers before resetting state
      const wrongAnswers = [...wrongansweredquestions];

      if (wrongAnswers.length === 0) {
        alert('No incorrect answers to review!');
        return;
      }

      // Batch all state updates together
      await Promise.all([
        // Reset states
        new Promise(resolve => {
          is_finished(false);
          is_reviewed(false);
          set_score(0);
          set_questionnumber(1);
          set_noquestionsattended(0);
          set_attendedquestions(0);

          // Reset all question type states
          is_imagewithtextfield(false);
          is_mapwithradiobuttons(false);
          is_imagewithradio(false);
          is_texttospeechwithtextfield(false);
          is_listenspeech(false);
          is_texttospeechwithradiobutton(false);
          is_drawquestions(false);
          is_questionwithradio(false);
          is_questionwithimages(false);
          is_questionwithtextfield(false);

          // Reset user answers
          set_user_answers_right1({});
          set_user_answers_right({});
          resolve();
        })
      ]);

      // Set the new question bank with wrong answers
      set_questionBank(wrongAnswers);
      set_totalquestions(wrongAnswers.length);
      setHasUsedCorrectMistakes(true);

      // Set the first question if there are any wrong answers
      if (wrongAnswers.length > 0) {
        const firstQuestion = wrongAnswers[0];
        set_presentquestion(firstQuestion);
        updateQuestionTypeState(firstQuestion.displayformat);

        // Set the appropriate question type
        const questionTypeSetters = {
          'ImagewithRadio': () => is_imagewithradio(true),
          'SpeakTextwithTextField': () => is_texttospeechwithtextfield(true),
          'ListenSpeech': () => is_listenspeech(true),
          'SpeakTextwithRadioButton': () => is_texttospeechwithradiobutton(true),
          'QuestionswithTextField': () => is_questionwithtextfield(true),
          'MapwithRadioButtons': () => is_mapwithradiobuttons(true),
          'QuestionswithImages': () => is_questionwithimages(true),
          'drawquestions': () => is_drawquestions(true)
        };

        const setQuestionType = questionTypeSetters[firstQuestion.displayformat] || (() => is_questionwithradio(true));
        setQuestionType();
      }
    } catch (error) {
      console.error('Error in playagain:', error);
      alert('Failed to load incorrect answers. Please try again.');
    } finally {
      setIsLoadingMistakes(false);
    }
  }

  const updateUserScore = async (updatedscore) => {
    let newscore = 0;
    if (updatedscore >= totalquestions) {
      newscore = user['score'] + data1.state['points'];
      user['score'] = newscore;
    } else {
      newscore = user['score'] - data1.state['points'];
      user['score'] = newscore;
    }
  };

  // const updateUserScore = async (jwt, updatedscore) => {
  //   let newscore = 0;
  //   if (updatedscore >= totalquestions) {
  //     newscore = user['score'] + data1.state['points'];
  //     user['score'] = newscore;
  //   }
  //   else {
  //     newscore = user['score'] - data1.state['points'];
  //     user['score'] = newscore;
  //   }
  // };

  const getQuestionfromDB = async () => {
    const specificcategory = data1.state['specificcategory'];

    const level1 = data1.state['levels'];
    const limits = data1.state['limits'];
    const eventdisplay = data1.state['eventdisplay'];

    start_limit = data1.state['start_limit'];
    end_limit = data1.state['end_limit'];
    randomize = data1.state['randomize'];


    if (randomize == undefined) {

      randomize = true
    }



    if (start_limit == undefined || end_limit == undefined) {
      start_limit = 0
      end_limit = data1.state['totalquestions'] - 1;
    }

    set_totalquestions(end_limit - start_limit + 1)


    const questions = data1.state['questions'];



    var specificcategoryreplace = ('' + specificcategory).replace(/%20/g, ' ');



    var questionno;
    let dict_answer = real_answers;
    let case_checkercondition = [];
    let requiredquestionarray = [];
    let correctanswerarray = [];
    let newaary = []

    for (questionno in questions) {




      correctanswerarray = [];
      newaary = []


      if (Number(questionno) >= start_limit && Number(questionno) <= end_limit) {


        newaary = [questions[questionno].correctanswer];
        if ("alternateanswerlist" in questions[questionno]) {
          if (questions[questionno].alternateanswerlist.length > 0) {


            newaary = questions[questionno].alternateanswerlist.concat(questions[questionno].correctanswer)



          }
        }


        dict_answer[questions[questionno].id] = newaary





        case_checkercondition[questions[questionno].id] =
          questions[questionno].ignorecases;

        requiredquestionarray[questionno] = questions[questionno];


      }
    }

    set_real_answers(dict_answer);
    set_case_checker(case_checkercondition);


    if (randomize) {
      requiredquestionarray.sort(() => Math.random() - 0.5)
    }
    else {
      requiredquestionarray.sort()

    }

    set_questionBank(requiredquestionarray);


    set_presentquestion(requiredquestionarray[0]);




    var displayformat = requiredquestionarray[0]["displayformat"]


    if (displayformat == 'ImagewithTextField') {
      is_imagewithtextfield(true);

    } else if (displayformat == 'ImagewithRadio') {
      is_imagewithradio(true);
    } else if (displayformat == 'SpeakTextwithTextField') {
      is_texttospeechwithtextfield(true);

    }
    else if (displayformat == 'ListenSpeech') {
      is_listenspeech(true);

    }

    else if (displayformat == 'SpeakTextwithRadioButton') {
      is_texttospeechwithradiobutton(true);

    }

    else if (displayformat == 'QuestionswithTextField') {
      is_questionwithtextfield(true);
    }
    else if (displayformat == 'drawquestions') {
      is_drawquestions(true);
    }
    else if (displayformat == 'MapwithRadioButtons') {
      is_mapwithradiobuttons(true)

    }
    else if (displayformat == 'QuestionswithImages') {
      // console.log("Setting is_mapwithradiobuttons ")
      is_questionwithimages(true);

    }

    else {
      is_questionwithradio(true);
    }



  };

  function closeFeedBack() {
    ////console.log("REached parent screen")


    setIsOpen(!isOpen);
    // set_batches([{}]);
    // getToken();
  }

  function closeFeedBackNew() {
    ////console.log("REached parent screen")

    setIsfbackOpen(!isfbackOpen)

  }


  function computeAnswer(answer, id) {

    playActive()

    let useranswermap = user_answers_right;
    useranswermap[id] = answer;

    set_user_answers_right(useranswermap);
    //////console.log(user_answers_right)
  }

  const getPracticeLimitDetails = async (username, jwt) => {
    try {
      // First check premium status
      const { isPremium } = await checkPremiumStatus();
      if (isPremium) {
        console.log('Premium user - practice limits do not apply');
        return true; // Skip practice limits for premium users
      }

      // For non-premium users, check practice limits
      console.log('Checking practice limits for user:', username);
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: jwt
        },
        body: JSON.stringify({
          username,
          source: 'quiz',
          timestamp: new Date().toISOString() // Add timestamp for debugging
        })
      };

      console.log('Sending request to check practice limit...');
      const startTime = Date.now();
      const response = await fetch('https://api.prod.quizwizard.net/check-practice-limit', requestOptions);
      const responseTime = Date.now() - startTime;

      console.log(`Practice limit check took ${responseTime}ms`);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response from server:', {
          status: response.status,
          statusText: response.statusText,
          responseText: errorText
        });
        return true; // If there's an error, allow access to prevent blocking users
      }

      const data = await response.json();
      console.log('Practice limit API response:', JSON.stringify(data, null, 2));

      // If the response doesn't have practiceAllowed, assume unlimited access
      if (data.practiceAllowed === undefined) {
        console.warn('No practiceAllowed in response, defaulting to unlimited access. Full response:', data);
        return true;
      }

      console.log(`Practice allowed: ${data.practiceAllowed}`);
      return data.practiceAllowed === true; // Ensure boolean return

    } catch (error) {
      console.error('Error checking practice limits:', {
        message: error.message,
        stack: error.stack,
        name: error.name
      });
      return true; // On error, allow access to prevent blocking users
    }
  };

  const confirmanswers = async () => {
    is_finished(true);
    is_reviewed(false);

    let actualScore = 0;

    // Process answers for scoring
    Object.entries(user_answers_right).forEach(([key, val]) => {
      if (real_answers && real_answers[key]) {
        const realAnswersReplaced = Array.isArray(real_answers[key])
          ? real_answers[key].map(word => word.toLowerCase())
          : [String(real_answers[key]).toLowerCase()];

        if (realAnswersReplaced.includes(String(val).trim().toLowerCase())) {
          actualScore += 1;
        } else if (Array.isArray(real_answers[key]) &&
          real_answers[key].includes(String(val).trim())) {
          actualScore += 1;
        }
      }
    });

    set_score(actualScore);
    is_finished(true);

    if (actualScore >= totalquestions) {
      playPass();
    } else {
      playFail();
    }

    // Update user activity
    updateEventyActivity(actualScore);

    // Increment practice attempt counter only on submission
    try {
      const [username] = await getToken();
      if (username) {
        const sessionPracticeData = JSON.parse(sessionStorage.getItem(PRACTICE_ATTEMPTS_KEY) || '{}');
        const practiceCount = sessionPracticeData[username] || 0;

        // Only increment if this is the first submission
        if (practiceCount === 0) {
          console.log('Incrementing practice attempt counter on submission');
          sessionStorage.setItem(PRACTICE_ATTEMPTS_KEY,
            JSON.stringify({
              ...sessionPracticeData,
              [username]: 1
            })
          );

          // End the practice session
          sessionStorage.removeItem(PRACTICE_SESSION_KEY);
        }
      }
    } catch (error) {
      console.error('Error updating practice attempt counter:', error);
    }
  };

  const updateQuestionTypeState = (type) => {
    // Reset all question type states
    is_imagewithtextfield(false);
    is_imagewithradio(false);
    is_texttospeechwithtextfield(false);
    is_listenspeech(false);
    is_texttospeechwithradiobutton(false);
    is_drawquestions(false);
    is_questionwithradio(false);
    is_questionwithimages(false);
    is_mapwithradiobuttons(false);
    is_questionwithtextfield(false);

    // Set the active question type
    switch (type) {
      case 'ImagewithTextField':
        return is_imagewithtextfield(true);
      case 'ImagewithRadio':
        return is_imagewithradio(true);
      case 'SpeakTextwithTextField':
        return is_texttospeechwithtextfield(true);
      case 'ListenSpeech':
        return is_listenspeech(true);
      case 'SpeakTextwithRadioButton':
        return is_texttospeechwithradiobutton(true);
      case 'QuestionswithTextField':
        return is_questionwithtextfield(true);
      case 'MapwithRadioButtons':
        return is_mapwithradiobuttons(true);
      case 'drawquestions':
        return is_drawquestions(true);
      case 'QuestionswithImages':
        return is_questionwithimages(true);
      default:
        return is_questionwithradio(true);
    }
  };

  const selectedanswers = () => {
    playNext();

    if (isNavigatingReview) {
      const currentIndex = questionBank.findIndex(q => q.id === presentquestion.id);
      if (currentIndex < questionBank.length - 1) {
        const nextQuestion = questionBank[currentIndex + 1];
        set_presentquestion(nextQuestion);
        set_questionnumber(currentIndex + 2);
        updateQuestionTypeState(nextQuestion.displayformat);
      } else {
        // At the last question, go back to the review summary screen
        is_reviewed(true);
        setIsNavigatingReview(false);
      }
    } else if (noofquestionsattended + 1 < totalquestions) {
      const nextQuestionIndex = noofquestionsattended + 1;
      const nextQuestion = optimizedQuestionBank[nextQuestionIndex];

      set_questionnumber(questionnumber + 1);
      set_presentquestion(nextQuestion);
      updateQuestionTypeState(nextQuestion.displayformat);
      set_noquestionsattended(noofquestionsattended + 1);
      set_user_answers_right1(user_answers_right);
    } else if (noofquestionsattended + 1 === totalquestions) {
      is_reviewed(true);
      var count = 0;
      for ([key, val] of Object.entries(user_answers_right)) {
        count = count + 1;
      }
      set_attendedquestions(count);
    } else {
      let actualScore = 0;
      var key, val;
      for ([key, val] of Object.entries(user_answers_right)) {
        if (case_checker[key] == "true") {
          val = val.replace(/\s+/g, '');
          if (real_answers[key].replace(/\s+/g, '').toLowerCase() == val.toLowerCase()) {
            actualScore = actualScore + 1;
          }
        } else {
          if (real_answers[key].trim() == val.trim()) {
            actualScore = actualScore + 1;
          }
        }
      }
      set_score(actualScore);
      is_finished(true);

      if (actualScore >= totalquestions) {
        playPass();
      } else {
        playFail();
      }
    }
  };
  function handleCallback(childData) {
    confirmanswers()
  }

  const backanswers = () => {
    playNext();

    if (isNavigatingReview) {
      const currentIndex = questionBank.findIndex(q => q.id === presentquestion.id);
      if (currentIndex > 0) {
        const prevQuestion = questionBank[currentIndex - 1];
        set_presentquestion(prevQuestion);
        set_questionnumber(currentIndex); // question number is index + 1, so this is correct
        updateQuestionTypeState(prevQuestion.displayformat);
      } else {
        // At the first question, go back to the review summary screen
        is_reviewed(true);
        setIsNavigatingReview(false);
      }
    } else if (noofquestionsattended > 0) {
      // Handle normal back navigation during quiz
      const prevQuestionIndex = noofquestionsattended - 1;
      const prevQuestion = optimizedQuestionBank[prevQuestionIndex];

      set_questionnumber(prev => prev - 1);
      set_presentquestion(prevQuestion);
      updateQuestionTypeState(prevQuestion.displayformat);
      set_noquestionsattended(prevQuestionIndex);
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const congratsOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const tryagainOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    getQuestionfromDB();

    const totalquestions = data1.state['totalquestions'];
    document.title = 'Practice Quiz';

    // Cleanup function
    return () => {
      isMounted = false;
      controller.abort(); // Abort any ongoing fetch requests
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location.pathname]); // Re-run if path changes

  const controlButtons = (
    <div className={!finished && cx(styles.buttonGroup_review)}>
      {presentquestion.id > 0 && finished == false ? (
        <button key="Back1" onClick={backanswers}>
          Back
        </button>
      ) : null}






      {reviewed == false && !finished ? (
        <button key="ReviewScreen" onClick={reviewscreen}>
          Review
        </button>
      ) : null}

      {reviewed == true && !finished ? (
        <button key="ConfirmScreen" onClick={confirmanswers}>
          Submit Answers
        </button>
      ) : ""}




      {presentquestion.id > 0 && finished == false && !reviewed ? (
        <button key="Next1" onClick={selectedanswers}>
          Next
        </button>
      ) : null}



    </div>

  );




  return (
    <div>
      {finished &&
        score >= totalquestions && (
          <div className={styles.overflowXHidden}>
            <Confetti />
          </div>
        )}

      <div>
        <div
          className={`${finished ? 'no-shadow inner ' : ''}${cx(
            styles.container
          )}`}
        >
          {finished && score < totalquestions ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/icon-sad.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{totalquestions}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/oops.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                Try Again
              </p>
            </div>
          ) : (
            ''
          )}

          {reviewed ? (
            <div>
              {/* <img
                className={cx(styles.img)}
                src={require('../../assets/images/oops.jpeg').default}
                alt=""
              /> */}
              <p className={`text-center color-black ${styles.title}`}>
                Review Answers
              </p>

            </div>
          ) : (
            ''
          )}
          {presentquestion.id > 0 && finished == false ? (
            <div className={styles.progress}>
              {questionBank.length > 0 ? (

                <>
                  <CountdownCircleTimer
                    isPlaying
                    duration={data1.state['time'] * totalquestions}
                    colors={['#eed017']}
                    size={105}
                    strokeWidth={7}
                    onComplete={handleCallback}
                  >

                    {({ remainingTime }) => {
                      // Calculate hours, minutes, and seconds
                      const hours = Math.floor(remainingTime / 3600);
                      const minutes = Math.floor((remainingTime % 3600) / 60);
                      const seconds = remainingTime % 60;

                      // Format seconds and minutes with leading zeros
                      const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
                      const formattedMinutes = minutes < 10 && hours > 0 ? `0${minutes}` : minutes;

                      //console.log(remainingTime % 60)
                      if (remainingTime % 60 != dummy) {
                        dummy = remainingTime % 60
                        // playTick()
                        // console.log(seconds)
                      }

                      // Display format based on duration
                      const timeDisplay = hours > 0
                        ? `${hours}:${formattedMinutes}:${formattedSeconds}`
                        : `${minutes}:${formattedSeconds}`;

                      // Label based on duration
                      const timeLabel = hours > 0 ? 'HRS' : 'MIN';

                      return (
                        <div
                          className="text-center"
                          style={{ fontSize: '17px' }}
                        >
                          {timeDisplay}
                          <br />
                          {timeLabel}
                        </div>
                      );
                    }}
                  </CountdownCircleTimer>


                </>
              ) : (
                ''
              )}{' '}
            </div>
          ) : (
            ' '
          )}
          {!finished && !reviewed &&
            <button className={cx(styles.editBtn)} onClick={togglePopup}  >
              <img src={require('../../assets/images/email.png').default} alt="" />
            </button>

          }




          {finished && score >= totalquestions ? (


            <div>



              <img
                className={cx(styles.img)}
                src={require('../../assets/images/happy.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{totalquestions}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/congo.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                You cleared the practice
              </p>
            </div>
          ) : (
            ''
          )}


          {isOpen && (
            <FeedBackPopup
              handleClose={togglePopup}
              eventname={data1.state['name']}
              selected={() => closeFeedBack()}
              presentquestion={presentquestion}
            />
          )}


          {isfbackOpen && (
            <FeedBackPopup
              handleClose={closeFeedBackNew}
              selected={() => closeFeedBackNew()}
              eventname={data1.state['name']}
              presentquestion={questionBank[fdback_id]}
            />
          )}



          {reviewed && (
            <div className={cx(styles.summary)}>
              <div className="item">
                <p className="s-title">{totalquestions}</p>
                <p className="sub-title">Question</p>
              </div>
              <div className="item">
                <p style={{ color: '#2ec32b' }} className="s-title">
                  {attendedquestions}
                </p>
                <p className="sub-title">Answered</p>
              </div>
              <div className="item">
                <p style={{ color: '#c32b2b' }} className="s-title">
                  {totalquestions - attendedquestions}
                </p>
                <p className="sub-title">Not Answered</p>
              </div>
              <div className="item">
                <p style={{ color: '#dd7029' }} className="s-title">
                  {Math.floor((attendedquestions / totalquestions) * 100)}%
                </p>
                <p className="sub-title">Completed</p>
              </div>
            </div>
          )}


          <div className="table-responsive">
            {reviewed ? (
              <table
                border={0}
                cellPadding={0}
                cellSpacing={0}
                className={cx(styles.table)}
              >
                <tr>
                  <th>Question </th>
                  <th>Your Answer</th>
                  <th>Review</th>
                </tr>
              </table>
            ) : (
              ''
            )}

            {reviewed &&
              data1.state['eventtype'] == 'Practice' &&
              questionBank.map(({ question, specificcategory, answers, correctanswer, meaning, id, }, index) => (
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  className={cx(styles.table)}
                  style={{ marginBottom: '30px' }}
                >
                  <tbody>


                    <tr>
                      <td>
                        {specificcategory.includes("Spell Bowl") || specificcategory.includes("Spell-it") ? index + 1 + ". " + meaning != undefined ? meaning : "" : index + 1 + ". " + question != undefined ? question : ""}

                      </td>



                      <td>
                        <div>{user_answers_right[id]}</div>
                      </td>

                      <td>
                        <button width="20" className={cx(button)} onClick={() => ReviewAnswers(index)}> Review Question No {index + 1}</button>
                      </td>
                    </tr>


                    {/* <ReviewAnswers
                      question={question}
                      correctanswer={

                        texttospeechwithtextfield ? correctanswer : user_answers_right[id] == correctanswer ? correctanswer : correctanswer
                        // user_answers_right[id] == correctanswer ? correctanswer : ''
                      }
                      id={id}
                      key={id}
                      selectedanswer={user_answers_right[id]}
                      eventtype={data1.state['eventdisplay']}
                    /> */}

                  </tbody>
                </table>
              ))}
          </div>

          {reviewed == true && questionwithradio && (
            <div className={styles.btnGroup}>
              <div className={!finished && cx(styles.buttonGroup)}>

                {presentquestion.id > 0 && finished == false && questionwithradio ? (
                  <button key="Back1" onClick={backanswers}>
                    Back
                  </button>
                ) : null}


                {reviewed == true && !finished && questionwithradio ? (
                  <button key="ConfirmScreen" onClick={confirmanswers}>
                    Confirm
                  </button>
                ) : ""}

              </div>
            </div>)}


          {finished && (
            <div className={cx(styles.summary)}>
              <div className="item">
                <p className="s-title">{totalquestions}</p>
                <p className="sub-title">Question</p>
              </div>
              <div className="item">
                <p style={{ color: '#2ec32b' }} className="s-title">
                  {score}
                </p>
                <p className="sub-title">Correct Answer</p>
              </div>
              <div className="item">
                <p style={{ color: '#c32b2b' }} className="s-title">
                  {totalquestions - score}
                </p>
                <p className="sub-title">Wrong Answer</p>
              </div>
              <div className="item">
                <p style={{ color: '#dd7029' }} className="s-title">
                  {Math.floor((score / totalquestions) * 100)}%
                </p>
                <p className="sub-title">Result</p>
              </div>



            </div>
          )}

          <div className="table-responsive">
            {finished ? (
              <table
                // border={2}
                cellPadding={5}
                cellSpacing={0}
                className={cx(styles.table)}
              >
                <tr>
                  <th>Question </th>
                  <th>Correct Answer</th>
                  <th>Your Answer</th>
                  <th>Result</th>
                  <th>Feedback</th>

                </tr>
              </table>
            ) : (
              ''
            )}

            {finished &&
              data1.state['eventtype'] == 'Practice' &&

              questionBank.map(({ question, answers, correctanswer, id, ignorecases, alternateanswerlist }, index) => (
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  className={cx(styles.table)}
                  style={{ marginBottom: '30px' }}
                >
                  <tbody>



                    <CorrectAnswers
                      question={question}
                      alternateanswers={real_answers[id]}


                      correctanswer={

                        texttospeechwithtextfield ? correctanswer : user_answers_right[id] == correctanswer ? correctanswer : correctanswer
                        // user_answers_right[id] == correctanswer ? correctanswer : ''
                      }
                      id={id}
                      key={id}
                      selectedanswer={user_answers_right[id] !== undefined ? user_answers_right[id] : ""}
                      eventtype={data1.state['eventdisplay']}
                      ignorecases={ignorecases}
                      selected={(index) => togglePopupwithId(index)}
                      questionid={index}

                    />

                  </tbody>
                </table>
              ))}
          </div>


          {presentquestion.id > 0 && finished == false && reviewed == false && imagewithradio ? (
            <ImagewithRadio
              question={presentquestion.question}
              answer={presentquestion.answers}
              imageurl={presentquestion.imageurl}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right1[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
            // questionCount={questionBank.length}

            />
          ) : null}




          {presentquestion.id > 0 && finished == false && reviewed == false && imagewithtextfield ? (
            <ImagewithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              imageurl={presentquestion.imageurl}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              questionCount={questionBank.length}
            />
          ) : null}



          {presentquestion.id > 0 && finished == false && reviewed == false && mapwithradiobuttons ? (
            <MapwithRadio
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              questionnumber={questionnumber}
              questionCount={questionBank.length}
              correctanswer={presentquestion.correctanswer}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              scale={presentquestion.scale}
              xaxis={presentquestion.xaxis}
              rotation={presentquestion.rotation}

            />
          ) : null}




          {presentquestion.id > 0 &&
            finished == false && reviewed == false &&
            texttospeechwithtextfield ? (
            <TexttoSpeechwithTextfield
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              meaning={presentquestion.meaning}
              questionCount={totalquestions}
              category={presentquestion.category}
              specific_category={presentquestion.specificcategory}
              audio={presentquestion.audio}
              example={presentquestion.example}
              word_to_pronounce={presentquestion.correctanswer}

            />
          ) : null}

          {presentquestion.id > 0 && finished == false && reviewed == false &&
            listenspeech ? (
            <ListenSpeech
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              meaning={presentquestion.meaning}
              questionCount={totalquestions}
              category={presentquestion.category}
              specific_category={presentquestion.specificcategory}
              audio={presentquestion.audio}
              example={presentquestion.example}

            />
          ) : null}


          {presentquestion.id > 0 &&
            finished == false && reviewed == false &&
            texttospeechwithradiobutton ? (
            <TexttoSpeechwithRadioButton
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              meaning={presentquestion.meaning}
              questionCount={totalquestions}
              category={presentquestion.category}
              specific_category={presentquestion.specificcategory}
              audio={presentquestion.audio}
              word_to_pronounce={presentquestion.correctanswer}

            />
          ) : null}



          {presentquestion.id > 0 &&
            finished == false && reviewed == false &&
            questionwithtextfield ? (
            <QuestionswithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              note={presentquestion.extranote}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.question}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              questionCount={totalquestions}
            />
          ) : null}


          {/* { presentquestion.id>0 && finished == false &&  is_drawquestions ?(<DrawShapeswithTextField question={presentquestion.question} answer={presentquestion.answers} id={presentquestion.id} key={presentquestion.id} selected={answer => computeAnswer(answer,presentquestion.id)} selectedanswer = {user_answers_right[presentquestion.id]}  subcategory = {presentquestion.subcategory} questionnumber = {questionnumber} nextbutton = { selectedanswers} />):null} */}

          {presentquestion.id > 0 && finished == false && questionwithradio && reviewed == false ? (
            <NewQuestionBox
              question={presentquestion.question}
              questionCount={totalquestions}
              questionnumber={questionnumber}
              answer={presentquestion.answers}
              id={presentquestion.id}
              // questionnumber={questionnumber}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer1={user_answers_right1[presentquestion.id]}
              category={data1.state['category']}
              controlButtons={controlButtons}
            />

          ) : null}



          {presentquestion.id > 0 && finished == false && questionwithimages && reviewed == false ? (
            <ImagesasOptions
              question={presentquestion.question}
              questionCount={totalquestions}
              questionnumber={questionnumber}
              answer={presentquestion.answers}
              id={presentquestion.id}
              // questionnumber={questionnumber}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer1={user_answers_right1[presentquestion.id]}
              category={data1.state['category']}
              controlButtons={controlButtons}
            />
          ) : null}


          {!questionwithradio && controlButtons}

          {presentquestion.id <= 0 ? (
            <div>
              <Lottie options={defaultOptions} height={400} width={400} />
            </div>
          ) : (
            ''
          )}

          <div className={styles.btnGroup}>
            {finished &&
              score < totalquestions &&
              (questionwithradio || texttospeechwithtextfield || texttospeechwithradiobutton || questionwithtextfield) ? (
              <div>
                <button
                  className={cx(button)}
                  onClick={playagain}
                  disabled={isLoadingMistakes || (!isPremiumUser && hasUsedCorrectMistakes)}
                  title={!isPremiumUser && hasUsedCorrectMistakes ? "Upgrade to premium to use this feature multiple times" : "Review and correct your mistakes"}
                >
                  {isLoadingMistakes ? 'Loading...' : 'Correct Mistakes'}
                </button>
              </div>
            ) : null}

            {finished && data1.state['eventtype'] != 'Assignments' && (
              <div>
                <Link
                  to={{
                    pathname: '/practiceevents',
                    state: data1.state['category'],
                  }}
                >
                  <button className={cx(button)}>Next Event</button>
                </Link>
              </div>
            )}

            {finished && data1.state['eventtype'] == 'Assignments' ? (
              <div>
                <Link
                  to={{ pathname: '/practice', state: data1.state['category'] }}
                >
                  <button className={cx(button)}> Next Event </button>
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default PracticeQuiz;